// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Y8Nu","productName":"Table_productName__1C7ya"};